<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">营销管理>拼团管理</div>
		<div class="title">
			<div class="left">
			</div>
			<div class="right">
				<el-select v-model="activeState" style="width: 150px;margin-right: 20px;" size="small">
					<el-option v-for="item in activeStateList" :key="item.value" :label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
				<el-input type="text" placeholder="请输入拼团名称" style="width: 200px;margin-right: 20px;"
					size="small"></el-input>
				<el-button type="primary" size="small">筛选</el-button>
			</div>
		</div>
		<div class="tabelContent" style="margin-top: 20px;">
			<el-table :data="dataList" :header-cell-style="{background:'#F2F2F4','text-align':'center'}"
				style="width: 100%">
				<el-table-column prop="name1" align="center" width="200" label="拼团产品">
					<template slot-scope="scope">
						<p>{{scope.row.name1}}</p>
						<p style="margin-top: 10px;"><el-tag
								style="margin-right: 10px;">模拟成团</el-tag><el-tag>超员成团</el-tag></p>
					</template>
				</el-table-column>
				<el-table-column label="成团人数" prop="name2" align="center" width="200"></el-table-column>
				<el-table-column prop="name3" align="center" label="拼团价(元/积分)"></el-table-column>
				<el-table-column prop="name4" align="center" label="团长价格(元)"></el-table-column>
				<el-table-column align="center" label="拼团活动时间" width="200">
					<template slot-scope="scope">
						<p>起：{{scope.row.name5}}</p>
						<p>止：{{scope.row.name6}}</p>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="name7" label="总团数"></el-table-column>
				<el-table-column align="center" label="状态">
					<template slot-scope="scope">
						{{scope.row.name8==1?'进行中':'已失效'}}
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" width="250">
					<template slot-scope="scope">
						<span v-if="scope.row.name8==1">
							<el-button type="text">编辑</el-button>
							<el-button type="text" @click="dialog_tuig = true">分享</el-button>
							<el-button type="text" @click="stopPt">停止拼团</el-button>
							<el-button type="text" @click="groupDetails = true">详情</el-button>
						</span>
						<span v-else>
							<el-button type="text" style="color: red;" @click="deletePt">删除</el-button>
							<el-button type="text" @click="groupDetails = true">详情</el-button>
						</span>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background style="margin-top: 30px;" layout="total, sizes, prev, pager, next, jumper"
				:page-size="10" :total="80">
			</el-pagination>
		</div>
		<!-- 推广 -->
		<el-dialog :visible.sync="dialog_tuig" width="25%">
			<div class="dia_title">优惠券H5</div>
			<div class="erwei">
				<img src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps1eb15cb7c10e81b9-5a84-438d-b0da-0865ed2f6393" />
			</div>
			<div>
				<div class="downerwei" @click="downloadCodeImg(img)">
					下载二维码
				</div>
			</div>
			<section class="form">
				<el-input :disabled="true" size="small" v-model="cjurl" style="width: 252px;margin-left:50px;margin-top: 20px;
					 margin-bottom:30px;"></el-input>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" v-clipboard:copy="cjurl" v-clipboard:success="onCopy"
						v-clipboard:error="onError" @click="dialog_tuig = copy">复 制</el-button>
				</span>
			</section>
		</el-dialog>
		<!-- 拼团详情 -->
		<el-dialog title="拼团详情" :visible.sync="groupDetails" width="70%">
			<div class="title">
				<div class="left">
				</div>
				<div class="right">
					<el-select v-model="serchXx" style="width: 150px;margin-right: 20px;" size="small">
						<el-option v-for="item in activeStateList" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
					<el-input type="text" placeholder="输入团长名称" style="width: 200px;margin-right: 20px;"
						size="small"></el-input>
					<el-button type="primary" size="small">筛选</el-button>
				</div>
			</div>
			<div class="tabelContent" style="margin-top: 20px;">
				<el-table :header-cell-style="{background:'#F2F2F4','text-align':'center'}" :data="groupDetailsList"
					style="width: 100%">
					<el-table-column prop="name1" align="center" label="团长名称"></el-table-column>
					<el-table-column label="开团时间" prop="name2" align="center"></el-table-column>
					<el-table-column prop="name3" align="center" label="结束时间"></el-table-column>
					<el-table-column prop="name4" align="center" label="拼团情况"></el-table-column>
					<el-table-column prop="name5" align="center" label="真实参团情况"></el-table-column>
					<el-table-column align="center" label="状态">
						<template slot-scope="scope">
							{{scope.row.name6==1?'拼团中':'已结束'}}
						</template>
					</el-table-column>
				</el-table>
				<el-pagination background style="margin-top: 30px;" layout="total, sizes, prev, pager, next, jumper"
					:page-size="10" :total="80">
				</el-pagination>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeState: "全部活动",
				activeStateList: [],
				activeTime: "",
				dataList: [{
						name1: "剪发",
						name2: 12,
						name3: 15,
						name4: 10,
						name5: "2020-08-17 20:00",
						name6: "2020-08-18 20:00",
						name7: 7,
						name8: 1
					},{
						name1: "剪发",
						name2: 12,
						name3: 15,
						name4: 10,
						name5: "2020-08-17 20:00",
						name6: "2020-08-18 20:00",
						name7: 7,
						name8: 2
					}
				],
				groupDetails: false,
				groupDetailsList: [{
					name1: "red",
					name2: "2020-08-17 20:00",
					name3: "2020-08-17 20:00",
					name4: "真实拼团",
					name5: 3,
					name6: 1
				}],
				deleteAd: false,
				dialog_tuig: false,
				cjurl: "",
				serchXx: ""
			}
		},
		mounted() {
			this.getlist()
		},
		methods: {
			getlist() {

			},
			//复制路劲
			onCopy() {
				this.$message({
					message: `复制成功！`,
					type: 'success'
				});
				this.snackBar.info(this.$t('prompt.copySuccess'))
			},
			onError() {
				this.$message.error(this.$t('prompt.copyFail'))
			},
			//停止拼团
			stopPt() {
				this.$confirm('已经拼团成功的用户，如停止正在进行的拼团活动，不会受影响； 正在拼团的用户，如果已开启模拟成团，将立即模拟成团； 如果未开启模拟成团，将会自动退款给该用户', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '停止成功!'
					});
				})
			},
			//删除拼团
			deletePt() {
				this.$confirm('从此列表删除，不会对拼图成功的用户造成影响', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	p {
		padding: 0;
		margin: 0;
	}

	.title {
		width: 100%;

		.left {
			float: left;
		}

		.right {
			float: right;
		}

		&::after {
			content: "";
			width: 1px;
			display: block;
			clear: both;
		}
	}

	// 弹出框内容
	.dia_title {
		width: 100%;
		text-align: center;
		font-size: 18px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #525252;
	}

	.erwei {
		width: 157px;
		height: 157px;
		margin: 20px auto;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.downerwei {
		cursor: pointer;
		width: 100%;
		text-align: center;
		font-size: 18px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #409EFF;
	}

	.dialog-footer {
		margin-top: -10px;
		margin-bottom: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}
</style>